<template>
    <div>
        <input type="text" :class="['w-full text-xs pr-4 pl-0 text-indigo-600', hidden]" style="direction: rtl;" v-model="message" disabled>
        <button type="button" class="-ml-3 mr-1 whitespace-no-wrap"
          v-clipboard:copy="message"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError">Copy Link</button>            
    </div>
</template>
}
<script>
  import VueClipboard from 'vue-clipboard2'
  VueClipboard.config.autoSetContainer = true // add this line
  Vue.use(VueClipboard)

  export default {

    props: {
      value: '',
      hidden: ''
    },

    data: function () {
      return {
        message: this.value
      }
    },
    methods: {
      onCopy: function (e) {
        alert('You just copied: ' + e.text)
      },
      onError: function (e) {
        alert('Failed to copy texts')
      }
    }
  }
</script>